module.exports = __webpack_public_path__ + "static/media/lock-1.c3612bf9.svg";